import { InstallExtensionFloating } from 'components/extension/InstallExtensionFloating'
import { isMobile } from 'react-device-detect'
import useTranslation from '../../../hooks/useTranslation'

export const NoneMemberTitle = (props: any) => {
  const { userInfo, isExtensionInstalled } = props
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center w-[343px] md:w-full">
      <div className="flex items-center md:flex-row flex-col gap-1 mb-2 md:relative w-full justify-center relative">
        <InstallExtensionFloating
          userInfo={userInfo}
          isExtensionInstalled={isExtensionInstalled}
        />{' '}
        <h1 className="font-bold text-[26px] md:text-[40px]">
          {t('productVideoEditor.noneMemberTitle.mainTitle')}
        </h1>
        <a
          className="flex gap-2 items-center md:absolute md:right-0 md:top-[25%]"
          href="https://angelleague.notion.site/AI-15bba20e97f3809b8d33d7b08aaacd3f"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="assets/img/icon_youtube.png"
            alt="youtube"
            width={26}
            height={26}
          />{' '}
          <span className="font-bold">{t('productVideoEditor.noneMemberTitle.viewSample')} {`>`}</span>
        </a>
      </div>
      <div className="">
        <p className="flex justify-center items-center gap-[4px]">
          <img
            src="assets/img/coupang_icon.png"
            alt="coupang"
            width={17.76}
            height={17.42}
          />
          <img
            src="assets/img/naver_icon.png"
            alt="ali"
            width={17.76}
            height={17.42}
          />
          <img
            src="assets/img/ali_icon.png"
            alt="ali"
            width={17.76}
            height={17.42}
          />
          {t('productVideoEditor.noneMemberTitle.justSelectProduct')}
        </p>
        {isMobile ? (
          <>
            <div className="flex flex-col items-center">
              <p className="">
                <span className='text-main font-bold"'>{t('productVideoEditor.noneMemberTitle.fastcut')}</span>
                {t('productVideoEditor.noneMemberTitle.addNarrationEditingBGM')}
              </p>
              <p>{t('productVideoEditor.noneMemberTitle.registerToChannel')}</p>
            </div>
          </>
        ) : (
          <>
            <div className="flex justify-center">
              <p className="text-main font-bold">{t('productVideoEditor.noneMemberTitle.fastcut')}</p>
              <p>{t('productVideoEditor.noneMemberTitle.fullService')}</p>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
